import { __rest } from "tslib";
import React from 'react';
import { Checkbox } from '../../Checkbox';
import { Radio } from '../../Radio';
import { Cell } from './Cell';
export function SelectionCell(_a) {
    var { selected, rowId, onChange, selectionMode, disabled } = _a, cellProps = __rest(_a, ["selected", "rowId", "onChange", "selectionMode", "disabled"]);
    if (selectionMode === 'single') {
        return (React.createElement(Cell, Object.assign({}, cellProps),
            React.createElement(Radio, { value: rowId, checked: selected, disabled: disabled, onChange: onChange })));
    }
    return (React.createElement(Cell, Object.assign({}, cellProps),
        React.createElement(Checkbox, { value: rowId, checked: selected, disabled: disabled, onChange: onChange })));
}
//# sourceMappingURL=SelectionCell.js.map